import { useDataProvider } from 'react-admin'
import { useQuery } from 'react-query'
import { ArrowPathIcon } from '@heroicons/react/24/outline'
import { CustomBarChart } from '../../components/customCharts/CustomBarChart'
import { CustomLineChart } from '../../components/customCharts/CustomLineChart'
import { getParamName, getParams } from '../../components/customCharts/helpers'
import { CustomChart as CustomChartType } from '../../components/customCharts/types'
import useChartContext from './useChartContext'

export const CustomChart = ({ chart }: { chart: CustomChartType }) => {
  const dp = useDataProvider()
  const { query, dateRange } = useChartContext()

  const paramName = getParamName(chart.dataType)
  const ids = getParams(chart.items)

  const { data, isLoading } = useQuery(
    ['charts', 'getGetChart', chart.dataType, query, dateRange, ids],
    () =>
      dp.getChart(chart.dataType, {
        query,
        ...dateRange,
        [paramName]: ids,
      }),
    {
      staleTime: 0,
      cacheTime: 0,
    }
  )

  if (isLoading || !data?.data)
    return (
      <div className="bg-gray-100 rounded-lg w-full h-[400px] flex items-center justify-center">
        <div className="flex flex-col items-center gap-2">
          <ArrowPathIcon className="h-8 w-8 text-gray-400 animate-spin" />
          <span className="text-sm text-gray-500">Loading chart data...</span>
        </div>
      </div>
    )

  return (
    <div className="h-[400px]">
      {chart.chartType === 'line' ? (
        <CustomLineChart data={data.data} chart={chart} />
      ) : (
        <CustomBarChart data={data.data} chart={chart} />
      )}
    </div>
  )
}
